import { pathJoin } from '../../../utils'

export const createDetailRoutesMap = (prefix: string) => ({
  information: pathJoin(prefix)('information').chain,
  history: pathJoin(prefix)('history').chain,
})
